import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import useScrollToTop from '../../hooks/useScrollToTop';

const Layout = ({ children }) => {
  const theme = useTheme();
  const isTouchDevice = useMediaQuery('(hover: none)');
  useScrollToTop();

  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: 'background.default',
        background: 'rgba(255, 255, 255, 0)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(90deg, rgba(0, 38, 255, 0.04) 0%, transparent 15%, transparent 75%, rgba(0, 38, 255, 0.04) 100%)',
          pointerEvents: 'none',
          zIndex: 0
        }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: isTouchDevice ? '56px' : {
            xs: '56px',
            sm: '64px',
          },
          backgroundColor: 'primary.dark',
          zIndex: theme.zIndex.appBar - 1
        }}
      />
      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          position: 'relative',
          zIndex: 1,
          marginTop: isTouchDevice ? 0 : {
            xs: '56px',
            sm: '64px',
          },
          marginBottom: {
            xs: '48px',
            sm: '64px',
          },
          width: '100%',
          overflow: 'hidden',
          transition: theme.transitions.create(['margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        {children}
      </Box>
      <Footer />
      <Sidebar />
    </Box>
  );
};

export default Layout; 